const VueClockPicker = require('./components/ClockPicker.vue').default;

module.exports = VueClockPicker;

